import eyercloud from '@/config/eyercloud'

class StripeService {

  async createCheckoutSession(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/create-checkout`, params)
    return response.data
  }

  async updateSubscription(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/update-subscription`, params)
    return response.data
  }

  async cancelSubscription(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/cancel-subscription`, params)
    return response.data
  }

  async list(params) {
    let response = await eyercloud.get(`/api/v2/eyercloud/stripe/list-products`, {params: params})
    return response.data
  }

  async getPrice(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/price`, params)
    return response.data
  }

  async getClinicSubscription(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/clinic-subscription`, params)
    return response.data
  }

  async declineMigration() {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/decline-migration`)
    return response.data
  }

  async updatePaymentMethod(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/update-payment-method`, params)
    return response.data
  }

  async getPaymenthistory(params) {
    let response = await eyercloud.post(`/api/v2/eyercloud/stripe/clinic-invoices`, params)
    return response.data
  }
}
const stripeService = new StripeService();
export default stripeService;
